// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".check-in-icon[data-v-289277be]{margin-left:.5rem}.check-in-icon img[data-v-289277be]{width:20px;height:20px}", ""]);
// Exports
module.exports = exports;
